import type { Uuid } from '@shared/api';

export type CategoryKind = 'PRODUCER' | 'ECO_PRODUCER' | 'PRODUCT';

export interface LocalizedString {
  ru: string;
  en: string;
  uz: string;
}

export interface Category {
  id: Uuid;
  kind: CategoryKind;
  slug: string;
  name: LocalizedString;
  parentId: Uuid | null;
  sortOrder: number;
}

export interface HsCode {
  code: string;
  description: string;
}

// Pick the localized name with sensible fallbacks (en, then any defined value,
// then slug). Use this everywhere category names appear in the UI.
export function categoryName(cat: Pick<Category, 'name' | 'slug'>, locale: string): string {
  const k = locale.startsWith('ru') ? 'ru' : locale.startsWith('uz') ? 'uz' : 'en';
  return cat.name[k] || cat.name.en || cat.name.ru || cat.name.uz || cat.slug;
}
